import { Helper } from "./helper.js";
import { NotificationHelper } from "./notificationHelper.js";
import { Config } from "../config/config.js";
import { AxiosRequestConfig, AxiosResponse, CancelToken } from "axios";
import { General } from "../../../siteManagement/general.js";
import { IntKeyDictionary, StringKeyDictionary } from "../../commonInterfaces.js";
import { InnosoftMobileApp } from "./innosoftMobileApp.js";
import axios from "axios";

enum messageBoxType {
    NONE = 0,
    NO_CONNECTION = 1,
    NOT_AUTH = 2
}

export function createHtppServiceInstance(): HTTPService {
    let activeRequests = 0;
    const defaultHeaders = { 'X-Requested-With': 'XMLHttpRequest' };

    const cusHeaderTabId = "CUS_HEADER_TABID";
    const cusHeaderTimeZone = "CUS_HEADER_TIMEZONE";

    const onShow = (e: kendo.ui.NotificationShowEvent) => {
        if (e.sender.getNotifications().length == 1) {
            const element = e.element.parent().parent();
            const newLeft = Math.floor($(window).width() / 2 - element.width() / 2);
            e.element.parent().parent().css({ left: newLeft });

            if (Config.settings.isMobileApp)
                $("button.back-to-mobile").on("click", function () {
                    InnosoftMobileApp.close();
                });
        }
    }

    const setGrayscale = (on: boolean) => {
        let el: HTMLElement;
        el = document.getElementById("main");
        if (el != null)
            el.style.filter = on ? "grayscale(90%)" : "grayscale(0)";

        el = document.getElementById("header");
        if (el != null)
            el.style.filter = on ? "grayscale(90%)" : "grayscale(0)";
    }

    const lostConnectionMessageBox = (type: messageBoxType, forceReload: boolean = false) => {
        if (Config.settings.disableMessageBoxOnReconnect)
            return;

        const element = document.getElementById("connection_notification");
        if (!element) {
            return;
        }
        const notificationElement = $(element);
        let n = $(notificationElement).data("kendoNotification");
        if (!n) {
            const url = window.location.toString();
            n = notificationElement.kendoNotification({
                autoHideAfter: 0,
                hideOnClick: false,
                position: {
                    top: Config.settings.isMobileApp ? null : 10,
                    bottom: Config.settings.isMobileApp ? 10 : null
                },
                show: onShow,
                templates: [
                    {
                        type: "noconnection",
                        template: '<div class="connection_notification_template">#= msg #</div>'
                    },
                    {
                        type: "noconnectionmobile",
                        template: `<div class="flex-container flex-container-row">
                                <div class="connection_notification_template">#= msg #</div>
                                <button class="back-to-mobile k-button k-button-sm k-rounded-sm k-button-solid k-button-solid-base">${Helper.getTranslation("Standard.MobileApp.BackToMobileApp")}</button>
                            </div>`
                    },
                    {
                        type: "notauth",
                        template: '<div class="connection_notification_template" id="connection_notification_links"><span>#= msg #</span><a class="connection_notification_reload" href="">#= reload #</a><a class="connection_notification_newtab" href="' + url + '" target="_blank">#= newtab #</a></div>'

                    }
                ]
            }).data("kendoNotification");
        }

        const notifications = n.getNotifications().length;

        if (type == messageBoxType.NONE) {
            if (notifications > 0) {
                n.hide();

                setGrayscale(false);
                NotificationHelper.showInfoMessage(Config.translations.sessionReconnect);

                if (forceReload || !Config.settings.disableMessageBoxOnReconnect) {
                    if (!Config.settings.isMobileApp)
                        setGrayscale(true);
                    window.location.reload();
                }
            }
        }
        else {
            let typeVisible = messageBoxType.NONE;
            if (notifications > 0)
                typeVisible = document.getElementById("connection_notification_links") != null ? messageBoxType.NOT_AUTH : messageBoxType.NO_CONNECTION;

            if (type == messageBoxType.NO_CONNECTION) {
                //show only once if no message showing
                if (notifications == 0)
                    NotificationHelper.showErrorMessage(Config.translations.noConnection);
                //already the same message? 
                if (typeVisible != messageBoxType.NO_CONNECTION) {
                    if (notifications > 0)
                        n.hide();
                    if (Config.settings.isMobileApp)
                        n.show({ msg: Config.translations.noConnection }, "noconnectionmobile");
                    else
                        n.show({ msg: Config.translations.noConnection }, "noconnection");
                }
            }
            else {
                let user = Config?.user?.fullName;
                if (!Helper.hasValue(user))
                    user = Config?.user?.userName;
                const msg = Helper.hasValue(user) ? Config.translations.namedUserLogout.replace("{user}", '[' + user + ']') :
                    Config.translations.userLogout;
                //show only once if no message showing
                if (notifications == 0)
                    NotificationHelper.showErrorMessage(msg);
                //already the same message? 
                if (typeVisible != messageBoxType.NOT_AUTH) {
                    if (notifications > 0)
                        n.hide();
                    n.show({
                        msg: msg,
                        reload: Config.translations.reloadLabel,
                        newtab: Config.translations.openInNewTab
                    }, "notauth")
                }
            }
            setGrayscale(true);
        }
    }

    const currentCallSettings: RequestSettings = {
        noBusyIndicator: false,
        progress: null,
        cancelToken: null,
        indicatorElement: null
    }

    const onRequestStart = () => {
        if (!currentCallSettings.noBusyIndicator) {
            activeRequests++;
            Helper.setBusyIndicator(true, currentCallSettings.indicatorElement).then();
        }
    }
    const onRequestEnd = (noBusyIndicator: boolean = false) => {
        if (!noBusyIndicator) {
            activeRequests--;
            if (activeRequests < 0) {
                activeRequests = 0;
            }
            if (activeRequests === 0) {
                Helper.setBusyIndicator(false, currentCallSettings.indicatorElement).then();
            }
        }
    }

    const resetCurrentCallSettings = () => {
        currentCallSettings.noBusyIndicator = false;
        currentCallSettings.progress = null;
        currentCallSettings.cancelToken = null;
        currentCallSettings.indicatorElement = null;
    }

    const isLocationHomeOrAccount = () => {
        return window.location.pathname.toString().startsWith("/Account/") ||
            window.location.pathname.toString().startsWith("/Home/")
    }

    const isAjaxFromLogin = (result: any) => {
        return !isLocationHomeOrAccount() &&
            (typeof result === 'string' && result === 'AJAX_ON_LOGIN');
    }

    const isNotValidLockOrHeartbeat = (url: string, result: any) => {
        return !isLocationHomeOrAccount() &&
            (url === "Heartbeat.ashx" || url === "Lock.ashx") &&
            typeof result === 'string' &&
            result === '';
    }

    const getRequest: GetRequest = <T extends any = any>(url: string, data?: any, headers: StringKeyDictionary<string> = defaultHeaders): Promise<T> => {
        headers[cusHeaderTabId] = General.Id;
        headers[cusHeaderTimeZone] = Intl.DateTimeFormat().resolvedOptions().timeZone;

        return new Promise<T>((resolve, reject) => {
            if (Helper.isNullOrEmpty(url)) {
                resolve(null);
            } else {
                onRequestStart();
                const noBusyIndicator = currentCallSettings.noBusyIndicator;
                handleAxiosCall<T>(
                    axios.get(
                        Config.baseUrl + url,
                        {
                            params: data,
                            headers,
                            onUploadProgress: currentCallSettings.progress,
                            cancelToken: currentCallSettings.cancelToken
                        }),
                    result => {
                        if (isAjaxFromLogin(result) || isNotValidLockOrHeartbeat(url, result)) {
                            onRequestEnd(noBusyIndicator);
                            lostConnectionMessageBox(messageBoxType.NOT_AUTH);
                            resolve(null);
                        }
                        else {
                            onRequestEnd(noBusyIndicator);
                            lostConnectionMessageBox(messageBoxType.NONE);
                            resolve(result);
                        }
                    },
                    msg => {
                        onRequestEnd(noBusyIndicator);
                        reject(msg);
                    });
            }
        });
    }

    const postRequest: PostRequest = <T extends any = any>(url: string, data?: any, headers: StringKeyDictionary<string> = defaultHeaders): Promise<T> => {
        headers[cusHeaderTabId] = General.Id;
        headers[cusHeaderTimeZone] = Intl.DateTimeFormat().resolvedOptions().timeZone;

        return new Promise<T>((resolve, reject) => {
            if (Helper.isNullOrEmpty(url)) {
                resolve(null);
            } else {
                onRequestStart();
                const noBusyIndicator = currentCallSettings.noBusyIndicator;
                handleAxiosCall<T>(
                    axios.post(
                        Config.baseUrl + url,
                        data,
                        {
                            headers,
                            onUploadProgress: currentCallSettings.progress,
                            cancelToken: currentCallSettings.cancelToken
                        }),
                    result => {
                        if (isAjaxFromLogin(result) || isNotValidLockOrHeartbeat(url, result)) {
                            onRequestEnd(noBusyIndicator);
                            lostConnectionMessageBox(messageBoxType.NOT_AUTH);
                            resolve(null);
                        }
                        else {
                            onRequestEnd(noBusyIndicator);
                            lostConnectionMessageBox(messageBoxType.NONE);
                            resolve(result);
                        }
                    },
                    msg => {
                        onRequestEnd(noBusyIndicator);
                        reject(msg);
                    });
            }
        });
    }

    const batchRequest: BatchRequest = <T extends any[]>(...urls: RequestConfig[]): Promise<T> => {
        return runBatchRequests(...urls);
    }

    class BatchBuilderImpl<T extends any[] = []> implements BatchBuilder<T> {
        private requests: RequestConfig[] = [];

        constructor(requests?: RequestConfig[]) {
            if (requests) {
                this.requests.push(...requests);
            }
        }

        add<R>(cfg: RequestConfig<R>): BatchBuilder<[...T, R]> {
            this.requests.push(cfg);
            return new BatchBuilderImpl<[...T, R]>(this.requests);
        }

        promise(): Promise<T> {
            const result = runBatchRequests<T>(...this.requests);
            this.requests = [];
            return result;
        }
    }

    const runBatchRequests = <T extends any[]>(...config: RequestConfig[]) => {
        const requests: HTTPRequestConfig[] = [];
        const promises: IntKeyDictionary<Promise<any>> = {};
        config.forEach((cfg, idx) => {
            if (typeof cfg === "string") {
                if (cfg.trim() === "") {
                    requests.push(null);
                } else {
                    requests.push({
                        data: null,
                        type: HTTPRequestType.Get,
                        url: cfg
                    });
                }
            } else if (cfg instanceof Promise) {
                requests.push(null);
                promises[idx] = cfg;
            } else {
                requests.push(cfg);
            }
        });

        return new Promise<T>((resolve, reject) => {
            const requestArray = requests.map((cfg, idx) => {
                if (Helper.hasValue(cfg)) {
                    const func = cfg.type === HTTPRequestType.Get ? HTTPService.get : HTTPService.post;
                    return func(cfg.url, cfg.data);
                } else if (promises[idx]) {
                    return promises[idx];
                } else {
                    return null;
                }
            });

            //onRequestStart();
            handleMultipleAxiosCall<T>(
                //... ... ... :| ...
                axios.all(requestArray) as any,
                result => {
                    //onRequestEnd();
                    resolve(result);
                },
                msg => {
                    //onRequestEnd();
                    reject(msg);
                });
        });
    }

    const handleAxiosCall = <T extends any>(call: Promise<AxiosResponse<T>>, onSuccess: (result: T) => void, onError: (reason: HTTPServiceError) => void) => {
        handleAxiosPromise(call, result => onSuccess(result.data), error => onError(error));
    }

    const handleMultipleAxiosCall = <T extends any[]>(call: Promise<T>, onSuccess: (result: T) => void, onError: (reason: HTTPServiceError) => void) => {
        handleAxiosPromise(call, result => onSuccess(result), error => onError(error))
    }

    const handleAxiosPromise = <T extends any>(promise: Promise<T>, onSuccess: (result: T) => void, onError: (reason: HTTPServiceError) => void) => {
        promise
            .then(result => {
                onSuccess(result);
            })
            .catch((error: AxiosErrorObject) => {
                const reason: HTTPServiceError = {
                    message: error.message,
                    status: error.status,
                    statusText: null,
                    source: null,
                    isCanceled: axios.isCancel(error)
                };

                if (error.response) {
                    //server responded => status code !== 2xx
                    reason.source = HTTPSServiceErrorSource.Response;
                    if (!reason.status) {
                        reason.status = error.response.status;
                        reason.statusText = error.response.statusText;
                    }
                } else if (error.request) {
                    //no response => error on request
                    reason.source = HTTPSServiceErrorSource.Request;
                    //NotificationHelper.showErrorMessage(Config.translations.noConnection);
                    lostConnectionMessageBox(messageBoxType.NO_CONNECTION);
                } else {
                    //error starting/executing the request
                    //check error.config
                    reason.source = HTTPSServiceErrorSource.Config;
                }

                console.log("Request error:", error);
                onError(reason);
            });
        resetCurrentCallSettings();
    }

    return {
        get: getRequest,
        post: postRequest,
        batch: batchRequest,
        get chainBatch() {
            return new BatchBuilderImpl();
        },
        noBusyIndicator: () => {
            currentCallSettings.noBusyIndicator = true;

            return {
                get: getRequest,
                post: postRequest,
                batch: batchRequest,
                get chainBatch() {
                    return new BatchBuilderImpl();
                },
                withProgress: HTTPService.withProgress,
                withCanceling: HTTPService.withCanceling
            };
        },
        withProgress: (callback) => {
            currentCallSettings.progress = (progressEvent) => {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                callback(percentCompleted);
            }

            return {
                get: getRequest,
                post: postRequest,
                noBusyIndicator: HTTPService.noBusyIndicator,
                withCanceling: HTTPService.withCanceling
            };
        },
        withCanceling: (callback) => {
            const source = axios.CancelToken.source();
            currentCallSettings.cancelToken = source.token;
            currentCallSettings.noBusyIndicator = true;

            callback(() => { source.cancel(); });

            return {
                get: getRequest,
                post: postRequest, batch: batchRequest, get chainBatch() {
                    return new BatchBuilderImpl();
                },
                noBusyIndicator: HTTPService.noBusyIndicator,
                withProgress: HTTPService.withProgress,
                withCanceling: HTTPService.withCanceling
            }
        },
        requestStart: (indicatorElement?: HTMLElement) => {
            currentCallSettings.indicatorElement = indicatorElement;
            onRequestStart();
        },
        requestEnd: (indicatorElement?: HTMLElement) => {
            currentCallSettings.indicatorElement = indicatorElement;
            onRequestEnd()
        }
    };
}

export const HTTPService: HTTPService = createHtppServiceInstance();

interface AxiosErrorObject {
    message: string;
    response: {
        status: number;
        statusText: string;
    };
    status: number;
    request: XMLHttpRequest;
    config: AxiosRequestConfig;
}

export interface HTTPRequestConfig {
    type: HTTPRequestType;
    url: string;
    data?: any
}

export enum HTTPRequestType {
    Get = 0, Post = 1
}

export enum HTTPSServiceErrorSource {
    Request = 0, Response = 1, Config = 2
}

export interface HTTPServiceError {
    status: number;
    statusText: string;
    message: string;
    source: HTTPSServiceErrorSource;
    isCanceled: boolean;
}

type RequestConfig<T = any> = string | HTTPRequestConfig | Promise<T>;

interface RequestSettings {
    noBusyIndicator: boolean;
    progress: (progressEvent: ProgressEvent) => void;
    cancelToken: CancelToken;
    indicatorElement: HTMLElement;
}

interface ProgressHandler {
    (percentage: number): void;
}

interface GetRequest {
    <T extends any = any>(url: string, data?: any, headers?: StringKeyDictionary<string>): Promise<T>;
}

interface PostRequest {
    <T extends any = any>(url: string, data?: any, headers?: StringKeyDictionary<string>): Promise<T>;
}

interface BatchRequest {
    <T extends any[]>(...urls: RequestConfig[]): Promise<T>;
}

type BatchBuilder<T extends any[] = []> = {
    add: <R = any>(cfg: RequestConfig<R>) => BatchBuilder<[...T, R]>;
    promise: () => Promise<T>;
};
interface HTTPService {
    get: GetRequest;
    post: PostRequest;
    batch: BatchRequest;
    chainBatch: BatchBuilder;
    noBusyIndicator: () => Omit<HTTPService, "noBusyIndicator">;
    withProgress: (callback: ProgressHandler) => Omit<HTTPService, "batch" | "chainBatch" | "withProgress">;
    withCanceling: (callback: (cancelTrigger: Function) => void) => Omit<HTTPService, "withCanceling">;
    requestStart?: any;
    requestEnd?: any;
}

export interface JsonResultClass<T = any> {
    Code: number;
    Message: string;
    Data: T;
    Id: string;
    AdditionalData: StringKeyDictionary<any>;
}